// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileJpgOutlinedSvg from "@ant-design/icons-svg/es/asn/FileJpgOutlined";
import AntdIcon from '../components/AntdIcon';

var FileJpgOutlined = function FileJpgOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileJpgOutlinedSvg
  }));
};

FileJpgOutlined.displayName = 'FileJpgOutlined';
export default React.forwardRef(FileJpgOutlined);